import { Collapse, Pagination, Spin, Tabs } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { useNotices } from "../hooks/useNotice";

export const Support = () => {
  const [activeKey, setActiveKey] = useState("notice");
  const [page, setPage] = useState(1);
  const history = useHistory();

  const { data, isLoading } = useNotices(activeKey, page);
  const notices = data?.result ?? [];
  const total = data?.total ?? 0;

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#notice" || hash === "#faq") {
      setActiveKey(hash.replace("#", ""));
    } else {
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}#${activeKey}`
      );
    }
  }, []);

  const handleChange = (key) => {
    setActiveKey(key);
    setPage(1);

    window.history.replaceState(null, "", `${window.location.pathname}#${key}`);
  };

  //   공지사항 부분
  const handleRowClick = (record) => {
    history.push({
      pathname: `/support/notice/${record.id}`,
      state: { notice: record },
    });
  };

  const pageSize = 20;

  const renderNoticeList = (emptyText) => {
    if (isLoading)
      return (
        <div className="flex justify-center items-center py-8">
          <Spin size="large" />
        </div>
      );
    if (notices.length === 0)
      return <div className="text-center py-8 text-gray-500">{emptyText}</div>;

    return (
      <div className="w-full max-w-[1020px]">
        <div className="w-full rounded-xl overflow-x-auto bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)]">
          <table className="w-full border-collapse text-[#171717] bg-white text-center font-normal">
            <thead className="bg-[#171717] text-white">
              <tr className="shrink-0">
                <th className="w-[10%] py-[14px] px-[8px] font-semibold border-b border-[#ddd] whitespace-nowrap">
                  번호
                </th>
                <th className="py-[14px] px-[8px] font-semibold border-b border-[#ddd] whitespace-nowrap">
                  제목
                </th>
                <th className="w-[20%] py-[14px] px-[8px] font-semibold border-b border-[#ddd] whitespace-nowrap">
                  작성일
                </th>
              </tr>
            </thead>
            <tbody className="text-lg md:text-xl">
              {notices.map((notice, index) => {
                const number = total - (page - 1) * pageSize - index;
                return (
                  <tr
                    key={notice.id}
                    onClick={() => handleRowClick(notice)}
                    className="cursor-pointer hover:bg-[#e6e6e6] font-medium"
                  >
                    <td className="py-[12px] px-[8px] border-b border-[#eee]">
                      {number}
                    </td>
                    <td className="py-[12px] px-[8px] border-b border-[#eee]">
                      <span className="cursor-pointer truncate hover:underline">
                        {notice.title}
                      </span>
                    </td>
                    <td className="py-[12px] px-[8px] border-b border-[#eee]">
                      {notice.created_at
                        ? dayjs(notice.created_at).format("YYYY.MM.DD")
                        : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // FAQ

  const renderFaqList = (emptyText) => {
    if (isLoading)
      return (
        <div className="flex justify-center items-center py-8">
          <Spin size="large" />
        </div>
      );
    if (notices.length === 0)
      return <div className="text-center py-8 text-gray-500">{emptyText}</div>;

    return (
      <Collapse
        accordion={true}
        size="large"
        expandIconPosition="end"
        expandIcon={({ isActive }) =>
          isActive ? (
            <FiChevronUp className="text-gray-500" size={18} />
          ) : (
            <FiChevronDown className="text-gray-500" size={18} />
          )
        }
        className="bg-white custom-collapse"
        items={notices.map((notice) => ({
          key: notice.id,
          label: notice.title,
          children: (
            <div className="p-4">
              <div className="whitespace-pre-wrap">{notice.description}</div>
            </div>
          ),
        }))}
      />
    );
  };

  return (
    <div className="w-full max-w-[1020px]">
      <h2 className="md:text-4xl text-3xl font-bold">고객지원</h2>
      <Tabs
        className="font-normal mb-5"
        activeKey={activeKey}
        onChange={handleChange}
        items={[
          { key: "notice", label: "공지사항" },
          { key: "faq", label: "자주 묻는 질문" },
        ]}
      />
      {activeKey === "notice" && renderNoticeList("공지사항이 없습니다.")}
      {activeKey === "faq" && renderFaqList("자주 묻는 질문이 없습니다.")}
      {total > 0 && (
        <Pagination
          current={page}
          total={total}
          pageSize={pageSize}
          onChange={(newPage) => setPage(newPage)}
          showSizeChanger={false}
          className="mt-12 justify-center"
        />
      )}
    </div>
  );
};
